import {Typography} from "@mui/material"
import Grid from "@mui/material/Grid"

import {Prop, PropLabel, Props, PropValue} from "@indebted/components/Props"
import {TextToHTML} from "@indebted/components/TextToHTML"
import {Page} from "@indebted/components/Page"

interface PaymentPlanMandateRevokedProps {
	I18n: any
	PaymentPlanInstalmentAmount: any
	PaymentPlanFrequency: any
	PaymentPlanStartDate: any
}

function PaymentPlanMandateRevoked({
	I18n,
	PaymentPlanInstalmentAmount,
	PaymentPlanFrequency,
	PaymentPlanStartDate,
}: PaymentPlanMandateRevokedProps) {
	return (
		<Page>
			<Grid>
				<Typography align="center" variant="h6">
					{I18n.MandateRevoked.Title}
				</Typography>
			</Grid>

			<Grid>
				<TextToHTML text={I18n.MandateRevoked.Message} className="amp-mask" />
			</Grid>

			<Grid>
				<Typography>{I18n.MandateRevoked.DetailsTitle}</Typography>
			</Grid>
			<Props>
				<Prop>
					<PropLabel align="right">{I18n.MandateRevoked.PlanLabel}</PropLabel>
					<PropValue align="left">
						{PaymentPlanInstalmentAmount} {PaymentPlanFrequency}
					</PropValue>
				</Prop>
				<Prop>
					<PropLabel align="right">{I18n.MandateRevoked.StartDateLabel}</PropLabel>
					<PropValue align="left">{PaymentPlanStartDate}</PropValue>
				</Prop>
			</Props>
		</Page>
	)
}
export {PaymentPlanMandateRevoked}
